<section class="modal-content modal-content-right">
  <button
    cjButton
    aria-label="Close"
    class="modal-close"
    tabIndex="-1"
    (click)="onClose()"
  >
    <cj-icon icon="times" pack="font-awesome-solid"></cj-icon>
  </button>

  <div
    *ngIf="isLoading"
    class="flex items-center justify-center text-center"
    [style.height.%]="100"
  >
    <img src="./assets/images/preloader.gif" width="90" />
  </div>

  <div *ngIf="!isLoading" class="flex flex-column">
    <div class="header-content mx-6 pt-6">
      <h5>Print Preview</h5>

      <div class="mt-3" *ngIf="isSummary">
        <a
          class="font-medium text-blue-90 invoice_returntoinvoicedetails_button"
          (click)="onReturnInvoiceDetails()"
        >
          <cj-icon
            class="mr-1"
            icon="chevron-left"
            pack="font-awesome-solid"
          ></cj-icon>
          Back to
          {{ invoiceType !== "estimate" ? "Invoice" : "Estimate" }} Details
        </a>
      </div>
    </div>

    <div class="body-content py-8 px-6">
      <div id="print-section">
        <ng-container *ngIf="invoiceType !== 'estimate'">
          <h5 class="mb-8">INVOICE</h5>

          <div class="dv-maincontent-wrap dv-card">
            <div class="bg-white">
              <app-invoice-template-default
                *ngIf="invoiceTemplate.templateId === 1"
                id="dvInvoice"
                [invoiceTemplateModel]="invoiceTemplate"
                [invoiceItems]="invoiceData.InvoiceItems"
                [manualInvoice]="invoiceData"
                [partialPayment]="partialPayment"
                [customerInfo]="customer"
                [grossTotal]="getGrossTotal()"
                [totalInvoiceAmount]="invoiceData.Balance"
                [businessInfo]="businessInfo"
                [locationData]="locationData"
                [customFieldValues]="customFieldValues"
                [paymentData]="paymentData"
                [workOrderData]="workOrderData"
                [manualInvoicePayments]="invoicePayments"
                [customerAddress]="
                  getDefaultCustomerAddress() || customerAddress
                "
                [tipAmt]="getTipAmount()"
                [displayTipAmt]="getTipAmount() || canAccessTipModule()"
              ></app-invoice-template-default>
              <app-invoice-template-1
                *ngIf="invoiceTemplate.templateId === 2"
                id="dvInvoice"
                [invoiceTemplateModel]="invoiceTemplate"
                [invoiceItems]="invoiceData.InvoiceItems"
                [manualInvoice]="invoiceData"
                [partialPayment]="partialPayment"
                [customerInfo]="customer"
                [grossTotal]="getGrossTotal()"
                [totalInvoiceAmount]="invoiceData.Balance"
                [businessInfo]="businessInfo"
                [locationData]="locationData"
                [customFieldValues]="customFieldValues"
                [customerAddress]="
                  getDefaultCustomerAddress() || customerAddress
                "
                [tipAmt]="getTipAmount()"
                [manualInvoicePayments]="invoicePayments"
                [displayTipAmt]="getTipAmount() || canAccessTipModule()"
              >
              </app-invoice-template-1>
              <app-invoice-template-2
                *ngIf="invoiceTemplate.templateId === 3"
                id="dvInvoice"
                [invoiceTemplateModel]="invoiceTemplate"
                [invoiceItems]="invoiceData.InvoiceItems"
                [manualInvoice]="invoiceData"
                [partialPayment]="partialPayment"
                [customerInfo]="customer"
                [grossTotal]="getGrossTotal()"
                [totalInvoiceAmount]="invoiceData.Balance"
                [businessInfo]="businessInfo"
                [customerAddress]="
                  getDefaultCustomerAddress() || customerAddress
                "
                [locationData]="locationData"
                [customFieldValues]="customFieldValues"
                [tipAmt]="getTipAmount()"
                [manualInvoicePayments]="invoicePayments"
                [displayTipAmt]="getTipAmount() || canAccessTipModule()"
              >
              </app-invoice-template-2>
              <app-invoice-template-3
                *ngIf="invoiceTemplate.templateId === 4"
                id="dvInvoice"
                [invoiceTemplateModel]="invoiceTemplate"
                [invoiceItems]="invoiceData.InvoiceItems"
                [manualInvoice]="invoiceData"
                [partialPayment]="partialPayment"
                [customerInfo]="customer"
                [grossTotal]="getGrossTotal()"
                [totalInvoiceAmount]="invoiceData.Balance"
                [businessInfo]="businessInfo"
                [customerAddress]="
                  getDefaultCustomerAddress() || customerAddress
                "
                [locationData]="locationData"
                [customFieldValues]="customFieldValues"
                [tipAmt]="getTipAmount()"
                [manualInvoicePayments]="invoicePayments"
                [displayTipAmt]="getTipAmount() || canAccessTipModule()"
              >
              </app-invoice-template-3>
              <app-invoice-template-4
                *ngIf="invoiceTemplate.templateId === 5"
                id="dvInvoice"
                [invoiceTemplateModel]="invoiceTemplate"
                [invoiceItems]="invoiceData.InvoiceItems"
                [manualInvoice]="invoiceData"
                [partialPayment]="partialPayment"
                [customerInfo]="customer"
                [grossTotal]="getGrossTotal()"
                [totalInvoiceAmount]="invoiceData.Balance"
                [businessInfo]="businessInfo"
                [customerAddress]="
                  getDefaultCustomerAddress() || customerAddress
                "
                [locationData]="locationData"
                [customFieldValues]="customFieldValues"
                [tipAmt]="getTipAmount()"
                [manualInvoicePayments]="invoicePayments"
                [displayTipAmt]="false"
              >
              </app-invoice-template-4>
              <app-invoice-template-5
                *ngIf="invoiceTemplate.templateId === 6"
                id="dvInvoice"
                [invoiceTemplateModel]="invoiceTemplate"
                [invoiceItems]="invoiceData.InvoiceItems"
                [manualInvoice]="invoiceData"
                [partialPayment]="partialPayment"
                [customerInfo]="customer"
                [grossTotal]="getGrossTotal()"
                [totalInvoiceAmount]="invoiceData.Balance"
                [businessInfo]="businessInfo"
                [customerAddress]="
                  getDefaultCustomerAddress() || customerAddress
                "
                [locationData]="locationData"
                [customFieldValues]="customFieldValues"
                [tipAmt]="getTipAmount()"
                [manualInvoicePayments]="invoicePayments"
                [displayTipAmt]="getTipAmount() || canAccessTipModule()"
              >
              </app-invoice-template-5>
            </div>

            <section class="others">
              <div
                class="col-md-12"
                *ngIf="
                  invoicePolicies.length && invoiceTemplate.templateId != 5
                "
              >
                <div class="form-group">
                  <label class="text-secondary">Terms and Conditions : </label>
                  <div
                    *ngFor="let policy of invoicePolicies"
                    [innerHTML]="policy.Content"
                    class="text-secondary tcp-container invoice_tcpcontent_text"
                  ></div>
                </div>
              </div>
              <div
                class="d-flex flex-column justify-content-center"
                *ngIf="customerSig"
              >
                <div class="d-flex justify-content-center">
                  <img class="img" [src]="customerSig.signatureUrl" />
                </div>
                <div class="d-flex justify-content-center">
                  <label class="invoice_customersignedon_text"
                    >Customer Signature on
                    {{
                      customerSig.createdDateTZBased
                        | date: "MM/dd/yyyy hh:mm:ss"
                    }}</label
                  >
                </div>
              </div>
              <div class="col-md-12" *ngIf="invoiceTemplate.templateId != 5">
                <div class="form-group">
                  <label class="text-secondary">RECEIPT</label><br />
                  <span>
                    A receipt can be printed after payment is accepted which may
                    serve as evidence of payment. If an email address is
                    provided during the payment process, a receipt will be
                    emailed to you after the payment is processed.
                  </span>
                </div>
              </div>

              <div class="col-md-12" *ngIf="invoiceTemplate.templateId != 5">
                <div class="form-group">
                  <label class="text-secondary">CONTACT</label><br />
                  <span>
                    If for any reason you wish to make a change to the payment
                    after submission, please contact
                    {{ businessInfo?.BusinessName }},
                    {{ businessInfo?.ContactNumber }} for assistance.
                  </span>
                </div>
              </div>
            </section>

            <div class="footnote" *ngIf="invoiceTemplate.templateId != 5">
              <ul>
                <li>
                  <p class="invoice_createdby_text">
                    <span>Created by</span>{{ invoice.createdByUserName }}
                  </p>
                  <p class="invoice_createdon_text">
                    <span>Created on</span
                    >{{
                      invoice.createdDateTZBased | date: "MM/dd/yyyy hh:mm:ss"
                    }}
                  </p>
                </li>
                <li>
                  <p class="invoice_updatedby_text">
                    <span>Updated by</span>{{ invoice.updatedByUserName }}
                  </p>
                  <p class="invoice_updatedon_text">
                    <span>Last updated on</span
                    >{{
                      invoice.updatedDateTZBased | date: "MM/dd/yyyy hh:mm:ss"
                    }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="invoiceType === 'estimate'">
          <section class="header-info">
            <div class="d-flex">
              <div class="col-md-6">
                <div class="img-placeholder" style="width: 50%">
                  <label for="additemfile">
                    <img
                      class="img px-2"
                      src="{{
                        businessInfo.Logo
                          ? businessInfo.Logo
                          : 'assets/images/grey-square.png'
                      }}"
                      style="width: 100%"
                      for="avatar"
                    />
                  </label>
                </div>
                <div class="form-group">
                  <label>Business Name</label><br />
                  <strong>{{ businessInfo.BusinessName }}</strong>
                </div>
                <div class="form-group">
                  <label>Address</label>
                  <br />
                  <strong
                    >{{ businessInfo.Address1 }}, {{ businessInfo.City }},
                    {{ businessInfo.StateId }} {{ businessInfo.PostalCode
                    }}{{
                      businessInfo.CountryCode
                        ? " " + businessInfo.CountryCode
                        : ""
                    }}</strong
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-row">
                  <div class="form-group d-flex justify-content-between">
                    <label>Estimate #</label>
                    <strong>{{
                      invoice.estimateNumber || "000-000-0000"
                    }}</strong>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group d-flex justify-content-between">
                    <label class="form-label">Estimate Date </label>
                    <strong>{{
                      invoice.estimateDate | date: "MM/dd/yyyy"
                    }}</strong>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group d-flex justify-content-between">
                    <label class="form-label">Validity Date</label>
                    <strong>{{
                      invoice.validityDate | date: "MM/dd/yyyy"
                    }}</strong>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="col-md-6">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Bill to : </label>
                    <div>
                      <span *ngIf="customer.CustomerTypeId == 1"
                        >{{ customer.FirstName }} {{ customer.LastName }}</span
                      >
                      <span *ngIf="customer.CustomerTypeId == 2">{{
                        customer.BusinessName
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Customer Address</label>
                  <div>{{ getDefaultCustomerAddress() }}</div>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="col-md-6"></div>
              <div class="col-md-6"></div>
            </div>
          </section>
          <div class="invoice-main pt-4 shadow">
            <section class="items-list px-3">
              <table class="table table-sm table-striped table-bordered">
                <thead class="bg-dark text-white">
                  <tr>
                    <th style="width: 55%">Item / Service</th>
                    <th style="width: 10%">Unit Cost</th>
                    <th style="width: 10%">Quantity</th>
                    <th style="width: 10%" class="text-right">Line Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of invoice.invoiceItems">
                    <td [class.with-description]="item.serviceDescription">
                      {{ item.itemName }} <br />
                      <div
                        *ngIf="item.serviceDescription"
                        class="item-description truncate"
                      >
                        {{ item.serviceDescription }}
                      </div>
                    </td>
                    <td>{{ item.rate || 0 | currency }}</td>
                    <td>{{ item.quantity }}</td>
                    <td class="text-right">
                      <strong>{{ item.amount || 0 | currency }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
            <section class="actions-totals pt-1 pb-3">
              <div class="d-flex">
                <div class="col-md-8">
                  <div class="form-group" *ngIf="invoice.notes">
                    <label>Notes : </label>
                    <p>{{ invoice.notes }}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div class="d-flex justify-content-between">
                      <label><strong>Line Total</strong></label>
                      <strong>{{
                        invoice.estimateTotalAmount || 0 | currency
                      }}</strong>
                    </div>
                    <div
                      class="d-flex justify-content-between"
                      *ngIf="invoice.partialDue"
                    >
                      <label><strong>Partial Payment</strong></label>
                      <strong
                        >{{ invoice.partialDueType === "USD" ? "$" : "%"
                        }}{{
                          invoice.partialDue
                            ? invoice.partialDue.toFixed(2)
                            : "0.00"
                        }}</strong
                      >
                    </div>
                    <div class="d-flex justify-content-between">
                      <label><strong>Gross Total</strong></label>
                      <strong>{{ getGrossTotal() || 0 | currency }}</strong>
                    </div>
                  </div>
                  <hr />
                  <strong>Adjustments</strong>
                  <div class="form-group pt-2">
                    <div class="d-flex justify-content-between">
                      <label>Discount</label>
                      <strong
                        >{{ invoice.discountType === "USD" ? "$" : "%"
                        }}{{
                          invoice.discount
                            ? invoice.discount.toFixed(2)
                            : "0.00"
                        }}</strong
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="d-flex justify-content-between">
                      <label>Upcharge</label>
                      <strong
                        >{{ invoice.upchargeType === "USD" ? "$" : "%"
                        }}{{
                          invoice.upcharge
                            ? invoice.upcharge.toFixed(2)
                            : "0.00"
                        }}</strong
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="d-flex justify-content-between">
                      <label>Tax</label>
                      <strong
                        >{{ invoice.taxType === "USD" ? "$" : "%"
                        }}{{
                          invoice.tax ? invoice.tax.toFixed(2) : "0.00"
                        }}</strong
                      >
                    </div>
                  </div>
                  <hr />
                  <div class="form-group due-section">
                    <div class="d-flex justify-content-between">
                      <label>Amount Due</label>
                      <strong>{{ invoice.balance || 0 | currency }}</strong>
                    </div>
                    <small
                      >Due on
                      {{ invoice.validityDate | date: "MM/dd/yyyy" }}</small
                    >
                  </div>
                </div>
              </div>
            </section>
          </div>
          <hr />
          <section
            class="others"
            *ngIf="invoicePolicies && invoicePolicies.length"
          >
            <div class="col-md-12">
              <div class="form-group">
                <label class="text-secondary">Terms and Conditions : </label>
                <div
                  *ngFor="let policy of invoicePolicies"
                  [innerHTML]="policy.Content"
                  class="text-secondary tcp-container"
                ></div>
              </div>
            </div>
          </section>
        </ng-container>
      </div>
    </div>

    <div class="footer-content flex justify-end mx-6 pb-6">
      <button cjButton size="large" (click)="printInvoice()">
        <cj-icon icon="print" pack="font-awesome-solid"></cj-icon>
        Print
      </button>
    </div>
  </div>
</section>
